// No /g flag: a global regex is stateful across .test() calls (lastIndex), and
// yup re-validates per keystroke — alternating pass/fail on identical input.
const PhoneRegex = /^01[0125][0-9]{8}$/m

export { PhoneRegex }
